const SITE = "https://veristamp.app";

export const ORG_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Veristamp",
  url: SITE,
  logo: `${SITE}/assets/veristamp_icon_1024.png`,
  email: "verify@veristamp.app",
  slogan: "Timestamped. Tamper-evident.",
};

export const APP_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "MobileApplication",
  name: "Veristamp",
  operatingSystem: "iOS, Android",
  applicationCategory: "BusinessApplication",
  description:
    "Veristamp turns move-in and move-out photos into timestamped, tamper-evident rental condition reports — signed by every party, verified by cryptography. Designed to support California AB 2801 photo requirements.",
  url: SITE,
  offers: [
    {
      "@type": "Offer",
      name: "Certified Condition Report",
      price: "11.99",
      priceCurrency: "USD",
    },
    {
      "@type": "Offer",
      name: "Landlord Pro (annual subscription)",
      price: "19.99",
      priceCurrency: "USD",
    },
  ],
};

export const faqPageSchema = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
});

export const breadcrumbSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: it.name,
    item: `${SITE}${it.path}`,
  })),
});
